var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scrollerComponent === _vm.SCROLLER_SHOP_COMPONENT.default)?_c('bpb-scroller-item',[_vm._t("teaser")],2):(_vm.scrollerComponent === _vm.SCROLLER_SHOP_COMPONENT.gallery)?_c('bpb-scroller-gallery-item',{staticClass:"sticker-wrapper"},[_vm._t("picture"),_vm._v(" "),_c('template',{slot:"description"},[_vm._t("teaser")],2)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }